import React from "react";
import ReactDOM from "react-dom";
import { Tooltip } from "react-tooltip";

import LockIcon from "assets/images/DeffenceScreenLock-icon.svg";
import ElipseDisabled from "assets/icons/elipseDisabled.svg";
import DefLeadCourseIcon from "assets/icons/def_lead_courses_exercises.png";
import BidPlay from "assets/icons/courses/bidPlay.png";
import { showMobile } from "helpers/adaptation";
import "./styles.scss";

interface Props {
  onPressItem?: any;
  isDisabled?: boolean;
  img: any;
  title: string;
  isInteractive?: boolean;
  isBidPlay: boolean;
  iconClassName?: string;
  courses?: string[];
}

const CourseItem = ({
  onPressItem,
  isDisabled,
  img,
  title,
  isInteractive,
  isBidPlay,
  iconClassName,
  courses
}: Props) => {
  const isDefLeadIcon = img === DefLeadCourseIcon;
  const tooltipId = `course-tooltip-${title?.replace(/\s/g, "-")}`;
  return (
    <div
      className={`list-item-courses-bidding ${
        isDisabled ? "list-item-courses-bidding-disable" : ""
      }`}
      onClick={onPressItem}
      {...(courses && courses.length > 0 ? { "data-tooltip-id": tooltipId } : {})}>
      <div
        className={`PracticeByCoursesTab-bidding-a ${
          showMobile ? "PracticeByCoursesTab-bidding-a-moible" : ""
        }`}>
        {isDisabled ? (
          <div style={{ position: showMobile ? "absolute" : "relative" }}>
            <div
              style={{
                position: "relative",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                background: "none"
              }}
              className={"icon-otr list-icons-courses list-icons-courses-disabled"}>
              <img src={ElipseDisabled} className="list-icons-courses-disabled-elipse" />
              <img
                className={"deffence-icon deffence-icon1 list-icons-courses-disabled-lock"}
                src={LockIcon}
                alt="icon"
              />
            </div>
          </div>
        ) : !isBidPlay ? (
          <>
            <div className="gradient-icon-otr"></div>
            <div className="icon-otr list-icons-courses">
              <img
                className={`deffence-icon deffence-icon1 ${
                  isInteractive ? "interactive-icon" : ""
                } ${isDefLeadIcon ? "def-lead-icon" : ""} ${iconClassName || ""}`}
                src={img}
                alt="icon"
              />
            </div>
          </>
        ) : (
          <img
            src={BidPlay}
            className={showMobile ? "bidPlay-mobile" : "bidPlay-desktop"}
            alt="bid-play-icon"
          />
        )}

        <div className="list-item-courses-item">
          <span
            className="bidding-icon-text"
            style={{
              color: isDisabled ? "rgba(120, 101, 158, 1)" : undefined
            }}>
            {title}
          </span>
        </div>
      </div>
      {courses &&
        courses.length > 0 &&
        ReactDOM.createPortal(
          <Tooltip id={tooltipId} place="bottom" className="course-tooltip" opacity={1}>
            <ul className="course-tooltip-list">
              {courses.map((course, index) => (
                <li key={index}>{course}</li>
              ))}
            </ul>
          </Tooltip>,
          document.body
        )}
    </div>
  );
};

export default CourseItem;
